import { render, staticRenderFns } from "./ChangeMealCard.vue?vue&type=template&id=56cd1366&"
import script from "./ChangeMealCard.vue?vue&type=script&lang=js&"
export * from "./ChangeMealCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports